import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { categoryLineForm } from "../../type";

const updateCategoryLine = async ({ data }: { data: categoryLineForm }) => {
  const formData = new FormData();
  formData.append("Id", String(data.id ?? 0));
  formData.append("ArticleCategoryId", String(data.articleCategoryId ?? 0));
  formData.append("Title", String(data.title ?? ""));
  formData.append("Line", String(data.line ?? "0"));
  formData.append("Priority", String(data.priority ?? "0"));
  formData.append(
    "NumberOfArticleToDisplay",
    String(data.numberOfArticleToDisplay ?? 0)
  );
  formData.append("IsActive", String(data.isActive ?? "false"));

  const res = await instance.put(
    MAG_HOME_END_POINTS.update_category_line,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return res.data;
};

export const useUpdateCategoryLine = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      MAG_HOME_END_POINTS.update_category_line,
      MAG_HOME_END_POINTS.category_lines_list,
    ],
    mutationFn: updateCategoryLine,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(
        `${e.response?.data.Message || "خطا در ویرایش لاین دسته بندی"}`
      );
    },
    onSuccess: () => {
      toast.success(`لاین دسته بندی با موفقیت ویرایش شد`);
      queryClient.invalidateQueries({
        queryKey: [MAG_HOME_END_POINTS.category_lines_list],
      });
    },
  });
};
